import type {
  AccessionLogDateBasis,
  BillingReportAccountType,
} from "../../services/reports.service";

export function billingDateBasisLabel(value: AccessionLogDateBasis): string {
  if (value === "date_of_service") return "Date of Service";
  if (value === "date_received") return "Date Received";
  if (value === "date_accessioned") return "Date Accessioned";
  return "Date First Reported";
}

export function billingAccountTypeLabel(
  value: BillingReportAccountType | "unassigned" | string
): string {
  if (value === "sending_lab") return "Sending Lab";
  if (value === "surgery_center") return "Surgery Center";
  if (value === "practice") return "Practice";
  return "Unassigned";
}
